import React from 'react';
import { motion } from 'framer-motion';
const chapters = [{
  icon: '🎨',
  title: 'Juegos por Edad',
  desc: 'Actividades específicas para cada etapa de 2 a 7 años.'
}, {
  icon: '📅',
  title: 'Rutinas Diarias',
  desc: 'Cómo integrar el aprendizaje en el día a día sin estrés.'
}, {
  icon: '🗣️',
  title: 'Desarrollo del Lenguaje',
  desc: 'Ejercicios divertidos para que hable claro y con confianza.'
}, {
  icon: '🏃‍♂️',
  title: 'Motricidad Fina y Gruesa',
  desc: 'Juegos para mejorar su coordinación y destreza.'
}, {
  icon: '❤️',
  title: 'Inteligencia Emocional',
  desc: 'Herramientas para gestionar berrinches y emociones.'
}, {
  icon: '📦',
  title: 'Materiales Caseros',
  desc: 'Crea juguetes educativos con cosas que ya tienes en casa.'
}];
export function Solution() {
  return <section className="py-20 px-4 bg-pastel-yellow/20 relative overflow-hidden" data-id="element-84">
      {/* Decorative */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-pastel-yellow rounded-full blur-3xl opacity-40 -translate-y-1/2 translate-x-1/2" data-id="element-85"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-86">
        <div className="text-center mb-16" data-id="element-87">
          <span className="inline-block bg-brand-purple text-white px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wider mb-4" data-id="element-88">
            Lo que descubrirás
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-brand-dark" data-id="element-89">
            Todo lo que necesitas en un solo lugar 📚
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-90">
          {chapters.map((chapter, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white p-6 rounded-3xl shadow-sm border-2 border-transparent hover:border-pastel-yellow hover:shadow-md transition-all" data-id="element-91">
              <div className="w-16 h-16 bg-pastel-yellow/30 rounded-2xl flex items-center justify-center text-3xl mb-4" data-id="element-92">
                {chapter.icon}
              </div>
              <h3 className="text-xl font-bold text-brand-dark mb-2" data-id="element-93">
                {chapter.title}
              </h3>
              <p className="text-gray-600" data-id="element-94">{chapter.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}